import type { Prototype } from "../prototype-types";

export const remyGordonPrototypes: Prototype[] = [
  {
    id: "remy-preorder-split-shipping-minimums",
    name: "Preorder Split Shipping Minimums",
    path: "/remy/preorder-split-shipping-minimums",
    description:
      "Single-brand side cart split by availability, with separate shipping minimums for ships-now and preorder items.",
    owner: "Remy Gordon",
    createdAt: "2026-05-27",
    lastUpdated: "2026-05-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=1200&h=800&fit=crop",
    creationTool: "cursor",
  },
];
